import React from 'react';
import * as S from './AnalyticsToolbar.styled';
export const AnalyticsToolbar = ({ children, actions, bottomContent }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Tools, null, children),
            React.createElement(S.Actions, null, actions)),
        bottomContent));
};
